import { TextField } from "@/app/fields";
import type { Errors } from "@/app/useDraft";
import { Field, Form, Switch, Textarea } from "@/ui";
import type { SupplierDraft } from "./supplierDraft";

interface Props { draft: SupplierDraft; errors: Errors<SupplierDraft>; set: <K extends keyof SupplierDraft>(k: K, v: SupplierDraft[K]) => void; isNew: boolean }

/** 供应商表单的字段，见 docs/03 3.4。不带币种：币种以价格为准（决策 D85）。 */
export function SupplierForm({ draft, errors, set, isNew }: Props) {
  return (
    <Form>
      <TextField id="s-name" label="名称" required value={draft.name} error={errors.name} onChange={(v) => set("name", v)} />
      <Field label="备注" htmlFor="s-note"><Textarea id="s-note" rows={3} value={draft.note} onChange={(e) => set("note", e.target.value)} /></Field>
      {!isNew && <Switch label="启用" checked={draft.status === "active"} onChange={(on) => set("status", on ? "active" : "disabled")} />}
    </Form>
  );
}
